<template>
  <div uk-grid>
    <div class="uk-width-1-2">
      <chat-table @selectChat="selectChat"> </chat-table>
    </div>
    <div class="uk-width-1-2">
      <ChatDetails> </ChatDetails>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import ChatDetails from './ChatDetails.vue';
import ChatTable from './ChatTable.vue';

export default defineComponent({
  components: {
    ChatTable,
    ChatDetails,
  },
  data() {
    return {
      selectedChat: undefined,
    };
  },
  methods: {
    selectChat(id: string) {
      this.selectedChat = id;
    },
  },
});
</script>
